import { Link } from 'react-router-dom';
import TitleH1 from "../Titles/title-h1";

const AdminIndex = () => {
    return (
        <div className="p-4 bg-gray-100 min-h-screen">
            <TitleH1>Admin</TitleH1>
            <ul className="list-none space-y-2">
                <li>
                    <Link to="/admin/genres" className="block px-4 py-2 bg-white hover:bg-blue-100 rounded shadow">
                        Handle Genres
                    </Link>
                </li>
                <li>
                    <Link to="/admin/authors" className="block px-4 py-2 bg-white hover:bg-blue-100 rounded shadow">
                        Handle Authors
                    </Link>
                </li>
                <li>
                    <Link to="/admin/books" className="block px-4 py-2 bg-white hover:bg-blue-100 rounded shadow">
                        Handle Books
                    </Link>
                </li>
                <li>
                    <Link to="/admin/users" className="block px-4 py-2 bg-white hover:bg-blue-100 rounded shadow">
                        Handle Users
                    </Link>
                </li>
            </ul>
        </div>
    );
}

export default AdminIndex;